module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "rounded-lg",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', [_vm._v("Spefüxe")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [(_vm.bbrbbr.length === 0) ? _c('div', {
    staticClass: "body-2 pa-4"
  }, [_vm._v("Keine Spefüxe eingetragen")]) : _vm._e(), _vm._v(" "), _c('v-simple-table', {
    attrs: {
      "dense": "",
      "fixed-header": ""
    }
  }, [_c('tbody', [_vm._l((_vm.bbrbbr), function(item) {
    return _c('tr', {
      key: item.id,
      on: {
        "dblclick": function($event) {
          (_vm.bbr = item) && (_vm.showKontakt = true)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(item.nachname) + ", " + _vm._s(item.vorname))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "20px"
      },
      on: {
        "click": function($event) {
          (_vm.bbr = item) && (_vm.showKontakt = true)
        }
      }
    }, [_c('v-icon', [_vm._v("info")])], 1)])
  }), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "3"
    }
  }, [_c('v-btn', {
    attrs: {
      "block": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showKontaktNeu = true
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1)])], 2)]), _vm._v(" "), _c('dialogKontakt', {
    attrs: {
      "visible": _vm.showKontakt,
      "bbr": _vm.bbr
    },
    on: {
      "update:visible": function($event) {
        _vm.showKontakt = $event
      },
      "close": function($event) {
        _vm.showKontakt = false
      }
    }
  }), _vm._v(" "), _c('dialogKontaktCreate', {
    attrs: {
      "visible": _vm.showKontaktNeu,
      "status": 'Spefux'
    },
    on: {
      "update:visible": function($event) {
        _vm.showKontaktNeu = $event
      },
      "close": function($event) {
        _vm.showKontaktNeu = false
      }
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6dcc6130"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module_klein/keilkandidaten.vue
// module id = 788
// module chunks = 15